import $ from 'jquery';
import { uuidv4 } from '../helpers/utils';

export class Facets {
    //TODO añadir las regiones con las normativas
    public static normatives : {[key : string]: string} = {
        'normativa-guantes-776' : 'region-normative-en-388-2016',
        'normativa-guantes-1452' : 'region-normative-en-407-2020',
        'normativa-guantes-42' : 'region-normative-en-407-2004',
        'normativa-guantes-834' : 'region-normative-en-374-2016',
        'normativa-guantes-44' : 'region-normative-en-511-2006',
    }

    public static translations: string[] = [
        'norma',
        'reglement',
        'standard'
    ]

    public static init(): void {
        // @ts-ignore
        if (typeof Drupal === 'undefined') return;

        // @ts-ignore
        Drupal.behaviors.juba = {
            attach(context: any, settings: any): void {
                const dropdowns = document.querySelectorAll<HTMLElement>('.js-facets-checkbox-links');
                const arr = Array.from(dropdowns);

                for (let i = 0; i < arr.length; i++) {
                    const dropdown = arr[i];

                    const dropdownId = dropdown.dataset.dropId;
                    const dropdownExists = document.querySelector(`[data-drop-id="${dropdownId}"]`) !== null;

                    if (dropdownExists) continue;

                    const checkboxes = dropdown.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

                    if (checkboxes.length === 0) continue;

                    const $dropdown = $(dropdown);
                    const childrenFacet = $dropdown.children('.facet-item');

                    childrenFacet.hide();

                    const [titleElement] = $dropdown.siblings('.facet-title');
                    const title = titleElement ? titleElement.innerText : 'Nada seleccionado';

                    const selector = Facets._generateSelector(checkboxes, title);
                    dropdown.parentElement?.appendChild(selector);

                    dropdown.classList.add('dropdown-facet');
                    dropdown.dataset.dropId = uuidv4();

                    $(selector).selectpicker({
                        title,
                    });
                }
            },
        };
    }

    private static _generateSelector(checkboxes: NodeListOf<HTMLInputElement>, title: string): HTMLElement {
        const map = new Map<number, HTMLInputElement>();

        const selector = document.createElement('select');
        selector.multiple = true;
        selector.title = `Selector de filtros: ${title}`;

        let lastSelectedValues: number[] = [];

        const arr = Array.from(checkboxes);

        for (let i = 0; i < arr.length; i++) {
            const checkbox = arr[i];

            const option = Facets._generateOption(checkbox, i);
            map.set(i, checkbox);

            if (checkbox.checked) {
                lastSelectedValues.push(i);
            }
            selector.appendChild(option);
        }

        selector.addEventListener('change', (e) => {
            const selected = (<string[]>$(selector).val()).map((s) => parseInt(s, 10));

            const diff = lastSelectedValues
                .filter((x) => !selected.includes(x))
                .concat(selected.filter((x) => !lastSelectedValues.includes(x)))[0];

            const checkbox = map.get(diff);
            if (checkbox) {
                $(selector).siblings('.dropdown-toggle').click();

                const link = <string>$(checkbox).siblings('a').attr('data-href');
                let idFacet = <string>$(checkbox).attr('id');
                if (!idFacet.includes('normativa')) {
                    const transalateFacet = (value: string) => Facets.translations.find((element) => {
                        if (value.includes(element)) {
                            return element;
                        }
                    });
                    idFacet = idFacet.replace(<string>transalateFacet(idFacet), 'normativa-guantes');
                }
                if (Facets.normatives.hasOwnProperty(idFacet)) {
                    const normativeText = $(checkbox).next('label').find('.facet-item__value').text();
                    const $tempElement = $('<div>').html(normativeText);
                    const subContent = $tempElement.find('sub').html();

                    $('.modal__title').text(`${Drupal.t('Normativa')} ${subContent}`);

                    Facets._showModal(Facets.normatives[idFacet], checkbox);
                    lastSelectedValues = selected;
                    return;
                }
                location.href = link;
            }

            lastSelectedValues = selected;
        });

        return selector;
    }

    private static _generateOption(checkbox: HTMLInputElement, index: number): HTMLElement {
        const label = checkbox.nextElementSibling;
        const text = label?.querySelector<HTMLElement>('.facet-item__value')?.innerText ?? 'unknown option';

        const option = document.createElement('option');
        option.innerText = text;
        option.value = `${index}`;

        if (checkbox.checked) {
            option.selected = true;
        }

        return option;
    }

    private static _showModal(normative: string, checkbox: HTMLInputElement) {
        Drupal.behaviors.juba.openModal(normative, checkbox);
        $('#btnNormative').trigger('click');
        const modalSections = $('#modalNormative .modal-body section');
        modalSections.css({ 'display': 'none' });
        setTimeout(() => {
            modalSections.filter(`[class*="${normative}"]`).css({ 'display': 'grid' });
        }, 100);
    }

}
